import React from "react";
import { Container } from "./styled";

function UpgradeContainer() {
  return (
    <Container>
      <h2 style={{ marginBottom: "0" }}>
        Graficas, analiticas personalisadas y más herramientas!
      </h2>
      <p>Contactate con ventas para tener más informacion.</p>
      <div className="btns-container">
        <a className="btn-primary" href="/app/suscriptions">
          Empieza ahora
        </a>
        <a className="btn-primary ghost" href="/app/login">
          INICIA SESIÓN
        </a>
      </div>
    </Container>
  );
}

export default UpgradeContainer;
